module.exports = __webpack_public_path__ + "img/power_socket.d0ec216a.svg";